import { useState, useEffect, useRef } from 'react';
import { buscarRecomendacoes } from '../utils/recomendacoes';

// Mesma URL da ParaVocePage — rastreia mudanças nessa planilha
const PARA_VOCE_CSV_URL = 'https://docs.google.com/spreadsheets/d/1-DexkhRwRrEamowes1qUirTAOF1BlE8AuyG_O70T2m8/export?format=csv&gid=2147167278';
const LS_KEY = 'paravoce_last_seen_fp';

const fingerprint = (itens) => {
  if (itens.length === 0) return null;
  return itens.length + ':' + itens.map((i) => i.titulo).join(',');
};

export function useParaVoceBadge() {
  const [showParaVoceBadge, setShowParaVoceBadge] = useState(false);
  const fpRef = useRef(null);

  useEffect(() => {
    let cancelled = false;

    buscarRecomendacoes(PARA_VOCE_CSV_URL).then((resultado) => {
      const fp = fingerprint(resultado.itens);
      fpRef.current = fp;
      if (!cancelled && fp && fp !== localStorage.getItem(LS_KEY)) {
        setShowParaVoceBadge(true);
      }
    }).catch(() => {});

    return () => { cancelled = true; };
  }, []);

  function markParaVoceSeen() {
    if (fpRef.current) localStorage.setItem(LS_KEY, fpRef.current);
    setShowParaVoceBadge(false);
  }

  return { showParaVoceBadge, markParaVoceSeen };
}
